// extracted by mini-css-extract-plugin
export default {"root":"IconSocialMediaYoutube_root__XeuUh"};